// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-c902f990]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.site-divider[data-v-c902f990]{background-color:hsla(0,0%,100%,.1);height:1px;left:-50%;position:relative;width:200%}.m-default[data-v-c902f990]{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
